// extracted by mini-css-extract-plugin
export default {"notice":"styles_notice__e08A2","title":"styles_title__-mXOw","body":"styles_body__PVS8Y","footer":"styles_footer__Sz2cl"};